import { render, staticRenderFns } from "./proposal-tab-proposal-document.vue?vue&type=template&id=0ed341d0&scoped=true"
import script from "./proposal-tab-proposal-document.vue?vue&type=script&lang=js"
export * from "./proposal-tab-proposal-document.vue?vue&type=script&lang=js"
import style0 from "./proposal-tab-proposal-document.vue?vue&type=style&index=0&id=0ed341d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed341d0",
  null
  
)

export default component.exports